import { ReactComponent as SharpPlayCircle } from 'assets/icons/icon-sharp-play-circle.svg';

export default SharpPlayCircle;
